import { Avatar } from "@jutro/ui";
import { envVars } from "envvars";
import { EdmMedicalPerson } from "lib/graphql/megaSchema";
import { avatarConfig } from "lib/tools/httpConfigs";

type Props = {
  staff: EdmMedicalPerson;
};

export const StaffCell = ({ staff }: Props) => {
  const { id, firstname, lastname } = staff;

  return (
    <div className="flex w-fit min-w-64 items-center gap-3">
      <Avatar
        type="photo"
        imgSrc={`${avatarConfig[envVars.REACT_APP_CONFIG]}/${id}`}
      />
      <span className="font-label">
        {firstname} {lastname}
      </span>
    </div>
  );
};
